import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { useState } from 'react';
import { Button } from 'primereact/button';
import { saveNewSupervisoryInstitution } from '../operations/save-new-supervisory-institution';

interface AddSupervisoryDialogModel {
  onHide: () => any;
}
export const AddSupervisoryDialog: React.FC<AddSupervisoryDialogModel> = ({
  onHide,
}) => {
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleApprove = async () => {
    await saveNewSupervisoryInstitution(name, setIsLoading, onHide);
  };

  return (
    <div>
      <EditText title={'שם גוף המפקח'} onChange={setName} />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ height: '30px' }}
          onClick={handleApprove}
          label={'אישור'}
          loading={isLoading}
        />
      </div>
    </div>
  );
};
